import { render, staticRenderFns } from "./ownerAppService.vue?vue&type=template&id=12f07174&scoped=true&"
import script from "./ownerAppService.vue?vue&type=script&lang=js&"
export * from "./ownerAppService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f07174",
  null
  
)

export default component.exports